import type { LayoutComponent } from '@tunasong/plugin-lib'
import type { Rider } from '@tunasong/schemas'
import type { FC } from 'react'
import RiderContent from '../content.js'

export interface RiderViewProps extends LayoutComponent<Rider> {}

const RiderView: FC<RiderViewProps> = props => {
  const { entity } = props
  return <RiderContent element={entity} />
}

export default RiderView
